<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-12 pt-3 pb-3 pl-4">
        <h3><i class="fas fa-briefcase"></i> Clusterização</h3>
      </div>
    </div>
    <ClusterAdd v-if="showAdd" ref="ClusterAdd" v-on:Back="onBack" />
    <ClusterList v-else ref="ClusterList" v-on:New="onNew" v-on:Edit="onEdit"/>
  </div>
</template>
<script>
import Tools from '@/components/tools/Tools.js'
import ClusterAdd from './components/add/clusteradd.vue'
import ClusterList from './components/list/clusterlist.vue'

export default {
  name: 'Cluster',
  data () {
    return {
      showAdd: false
    }
  },
  components: {
    ClusterAdd,
    ClusterList
  },
  mounted () {
    // Tools.MinimizedSidebar()
  },
  beforeDestroy () {
    this.$eventHub.off('Filter')
    Tools.MinimizedASidebar()
  },
  methods: {
    onLoad () {},
    onNew () {
      this.showAdd = true
    },
    onEdit (obj) {
      this.showAdd = true
      this.$nextTick(() => {
        this.$refs.ClusterAdd.onEdit(obj)
      })
    },
    onBack () {
      this.showAdd = false
      // this.$refs.ClusterList.onLoad()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/clusters/clusters.vue